import React from 'react';
import { cn } from '@/utils/cn';

export function ProjectOverviewMain() {
  return (
    <div className="space-y-6">
      {/* Mô tả dự án */}
      <section className="rounded-md bg-white p-4  border border-slate-100 space-y-3">
        <div className="flex items-center justify-between border-b border-slate-50 pb-2">
          <h3 className="text-sm font-normal text-slate-900 tracking-wider">Mô tả dự án</h3>
          <button className="text-xs lg:text-sm font-normal text-emerald-600 hover:underline flex items-center gap-1">
            Xem thêm <i className="ri-arrow-down-s-line" />
          </button>
        </div>
        <p className="text-xs lg:text-sm font-normal text-slate-600 leading-relaxed">
          Thi công cảnh quan toàn bộ Khu đô thị Eco Garden bao gồm hệ thống cây xanh, thảm cỏ, đường dạo, tiểu cảnh, hồ nước, hệ thống tưới tự động và chiếu sáng cảnh quan...
        </p>
      </section>

      {/* Hạng mục chính */}
      <section className="rounded-md bg-white p-4  border border-slate-100 space-y-4">
        <h3 className="text-sm font-normal text-slate-900 tracking-wider border-b border-slate-50 pb-2">Hạng mục chính</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="text-xs font-normal text-slate-400 border-b border-slate-50">
                <th className="py-3 pr-4 font-normal">Hạng mục</th>
                <th className="py-3 px-4 text-right font-normal">Giá trị (VND)</th>
                <th className="py-3 px-4 font-normal">Tiến độ</th>
                <th className="py-3 pl-4 text-right font-normal">Trạng thái</th>
              </tr>
            </thead>
            <tbody className="text-xs lg:text-sm">
              <MilestoneRow name="1. San nền và chuẩn bị mặt bằng" value="2.850.000.000" progress={100} status="Hoàn thành" statusColor="bg-emerald-50 text-emerald-600" />
              <MilestoneRow name="2. Trồng cây xanh" value="8.750.000.000" progress={60} status="Đang thực hiện" statusColor="bg-blue-50 text-blue-600" />
              <MilestoneRow name="3. Hệ thống tưới tự động" value="5.200.000.000" progress={30} status="Đang thực hiện" statusColor="bg-blue-50 text-blue-600" />
              <MilestoneRow name="4. Hệ thống chiếu sáng" value="4.100.000.000" progress={0} status="Chưa bắt đầu" statusColor="bg-slate-50 text-slate-500" />
              <MilestoneRow name="5. Tiểu cảnh & hồ nước" value="3.750.000.000" progress={0} status="Chưa bắt đầu" statusColor="bg-slate-50 text-slate-500" />
            </tbody>
            <tfoot>
              <tr className="border-t-2 border-double border-slate-100 font-normal text-slate-900">
                <td className="py-4 pr-4">Tổng cộng</td>
                <td className="py-4 px-4 text-right">24.650.000.000</td>
                <td colSpan={2}></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>

      {/* Tài liệu liên quan */}
      <section className="rounded-md bg-white p-4  border border-slate-100 space-y-4">
        <div className="flex items-center justify-between border-b border-slate-50 pb-2">
          <h3 className="text-sm font-normal text-slate-900 tracking-wider">Tài liệu liên quan</h3>
          <button className="h-8 px-3 rounded-md bg-slate-50 text-xs lg:text-sm font-normal text-slate-600 hover:bg-slate-100 transition-all">Xem tất cả</button>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-5 gap-4">
          <FileCard icon="ri-file-pdf-2-line" color="text-rose-500" bg="bg-rose-50" name="Hợp đồng thi công" size="1.2 MB" />
          <FileCard icon="ri-file-image-line" color="text-blue-500" bg="bg-blue-50" name="Bản vẽ thiết kế" size="4.5 MB" />
          <FileCard icon="ri-file-excel-2-line" color="text-emerald-500" bg="bg-emerald-50" name="Bảng dự toán chi tiết" size="2.1 MB" />
          <FileCard icon="ri-file-word-2-line" color="text-sky-500" bg="bg-sky-50" name="Kế hoạch thi công" size="1.6 MB" />
          <FileCard icon="ri-folder-open-line" color="text-amber-500" bg="bg-amber-50" name="Hồ sơ pháp lý" count="12 tài liệu" />
        </div>
      </section>
    </div>
  );
}

function MilestoneRow({ name, value, progress, status, statusColor }: any) {
  return (
    <tr className="border-b border-slate-50 hover:bg-slate-50/50 transition-colors group">
      <td className="py-3 pr-4 font-normal text-slate-700">{name}</td>
      <td className="py-3 px-4 text-right font-normal text-slate-900">{value}</td>
      <td className="py-3 px-4">
        <div className="flex items-center gap-3">
          <div className="h-1.5 flex-1 rounded-full bg-slate-100 overflow-hidden">
            <div className={cn("h-full transition-all duration-700", progress === 100 ? "bg-emerald-500" : progress > 50 ? "bg-blue-500" : "bg-amber-500")} style={{ width: `${progress}%` }} />
          </div>
          <span className="text-xs font-normal text-slate-400 w-8">{progress}%\</span>
        </div>
      </td>
      <td className="py-3 pl-4 text-right">
        <span className={cn("px-2 py-0.5 rounded-md text-xs font-normal whitespace-nowrap", statusColor)}>{status}</span>
      </td>
    </tr>
  );
}

function FileCard({ icon, color, bg, name, size, count }: any) {
  return (
    <div className="flex flex-col items-center p-3 rounded-md border border-slate-50 hover:border-emerald-200 hover:bg-slate-50/50 transition-all cursor-pointer group text-center">
      <div className={cn("w-10 h-10 rounded-md flex items-center justify-center mb-2 transition-transform group-hover:scale-110", bg, color)}>
        <i className={cn(icon, "text-xl")} />
      </div>
      <p className="text-xs font-normal text-slate-700 line-clamp-1 mb-0.5">{name}</p>
      <span className="text-xs font-normal text-slate-400">{size || count}</span>
    </div>
  );
}
